import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { EMAIL_TEMPLATES_ACTIONS, EMAIL_TEMPLATES_TYPES } from "./actions";
import {
  getEmailTemplate as APIgetEmailTemplate,
  getEmailTemplates as APIgetEmailTemplates,
  createEmailTemplate as APIcreateEmailTemplate,
  updateEmailTemplate as APIupdateEmailTemplate,
  deleteEmailTemplate as APIdeleteEmailTemplate
} from "../../services/api/emailTemplates";
import { navigateTo } from "../navigation/saga";
import { emailTemplatesFilters } from "./selectors";

export function* watchEmailTemplatesActions() {
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.LOAD_ALL_REQUEST, getEmailTemplates)
  ]);
  yield all([takeEvery(EMAIL_TEMPLATES_TYPES.LOAD_REQUEST, getEmailTemplate)]);
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.CREATE_REQUEST, createEmailTemplate)
  ]);
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.UPDATE_REQUEST, updateEmailTemplate)
  ]);
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.DELETE_REQUEST, deleteEmailTemplate)
  ]);
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.CREATE_SUCCESS, getEmailTemplates)
  ]);
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.DELETE_SUCCESS, getEmailTemplates)
  ]);
  yield all([
    takeEvery(EMAIL_TEMPLATES_TYPES.UPDATE_FILTERS, getEmailTemplates)
  ]);
}

function* getEmailTemplates(action) {
  try {
    const filters = yield select(emailTemplatesFilters);
    const emailTemplates = yield call(APIgetEmailTemplates, filters);
    yield put(EMAIL_TEMPLATES_ACTIONS.loadAllSuccess(emailTemplates));
  } catch (e) {
    yield put(EMAIL_TEMPLATES_ACTIONS.loadAllFailure(e));
  }
}

function* getEmailTemplate(action) {
  const { id } = action.payload;
  try {
    const emailTemplate = yield call(APIgetEmailTemplate, id);
    yield put(EMAIL_TEMPLATES_ACTIONS.loadSuccess(emailTemplate));
  } catch (e) {
    yield put(EMAIL_TEMPLATES_ACTIONS.loadFailure(e));
  }
}

function* createEmailTemplate(action) {
  const { values } = action.payload;
  try {
    const emailTemplate = yield call(APIcreateEmailTemplate, values);
    yield put(EMAIL_TEMPLATES_ACTIONS.createSuccess(emailTemplate));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/email-templates"
    );
  } catch (e) {
    yield put(EMAIL_TEMPLATES_ACTIONS.createFailure(e));
  }
}

function* updateEmailTemplate(action) {
  const { id, values } = action.payload;
  try {
    const emailTemplate = yield call(APIupdateEmailTemplate, id, values);
    yield put(EMAIL_TEMPLATES_ACTIONS.updateSuccess(emailTemplate));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/email-templates"
    );
  } catch (e) {
    yield put(EMAIL_TEMPLATES_ACTIONS.updateFailure(e));
  }
}

function* deleteEmailTemplate(action) {
  const { id } = action.payload;
  try {
    const emailTemplate = yield call(APIdeleteEmailTemplate, id);
    yield put(EMAIL_TEMPLATES_ACTIONS.deleteSuccess(emailTemplate));
  } catch (e) {
    yield put(EMAIL_TEMPLATES_ACTIONS.deleteFailure(e));
  }
}
